import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import EventTypes from "../shared/EventTypes";
import DateField from "../sidebar/edit/Fields/DateField";

export default class ActiveContextPanel extends AbstractProvidedClass {
    collapsed = true;

    constructor(provider) {
        super(provider);

        this.container = this.p.createDiv()
            .parent('#p5canvas')
            .class('planner-active-layer planner-ui-overlay');

        // Header with label and toggle
        let header = this.p.createDiv()
            .parent(this.container)
            .style('display', 'flex')
            .style('align-items', 'center')
            .style('justify-content', 'space-between')
            .style('cursor', 'pointer');
        this.p.createDiv('Active context')
            .parent(header)
            .class('input-label')
            .style('margin', '0');
        this.toggleBtn = this.p.createButton('◂')
            .parent(header)
            .class('btn-icon-clear')
            .style('line-height', '1');
        header.elt.addEventListener('click', () => this.toggle());

        // Collapsible content (starts collapsed)
        this.content = this.p.createDiv()
            .parent(this.container)
            .style('display', 'none');

        // Layer dropdown
        this.layerRow = document.createElement('div');
        this.content.elt.appendChild(this.layerRow);
        this.selectEl = document.createElement('select');
        this.selectEl.className = 'input-text';
        this.selectEl.style.margin = '0';
        this.selectEl.style.width = '100%';
        this.layerRow.appendChild(this.selectEl);
        this.selectEl.onchange = () => {
            this._activeLayerId = this.selectEl.value || null;
        };

        // Added date
        this.addedDateField = DateField.setup(this.provider)
            .label('Added')
            .onInput(() => this.validateDates('added'))
            .make();
        this.addedDateField.field.parent(this.content);
        this.addedDateField.field.elt.querySelector('.input-label').style.fontSize = '0.75em';
        this.addedDateField.field.elt.querySelector('.input-label').style.margin = '0';

        // Removed date
        this.removedDateField = DateField.setup(this.provider)
            .label('Removed')
            .onInput(() => this.validateDates('removed'))
            .make();
        this.removedDateField.field.parent(this.content);
        this.removedDateField.field.elt.querySelector('.input-label').style.fontSize = '0.75em';
        this.removedDateField.field.elt.querySelector('.input-label').style.margin = '0';

        this.on(EventTypes.UPDATE_LAYER_NAME, () => this.populateOptions());
        this.on(EventTypes.ADD_LAYER, () => this.populateOptions());
        this.on(EventTypes.REMOVE_LAYER, () => this.populateOptions());

        this.hide();
    }

    toggle() {
        this.collapsed = !this.collapsed;
        this.content.elt.style.display = this.collapsed ? 'none' : '';
        this.toggleBtn.html(this.collapsed ? '◂' : '▾');
    }

    validateDates(which) {
        let added = this.addedDate;
        let removed = this.removedDate;
        if (!added || !removed) {
            this.hideError();
            return true;
        }
        let a = added.padEnd(10, '-00');
        let r = removed.padEnd(10, '-31');
        if (r >= a) {
            this.hideError();
            return true;
        }
        let field = which === 'removed' ? this.removedDateField : this.addedDateField;
        field.showError('Removed date must be later than added');
        return false;
    }

    hideError() {
        if (this.addedDateField.errorDiv) this.addedDateField.errorDiv.hide();
        if (this.removedDateField.errorDiv) this.removedDateField.errorDiv.hide();
    }

    get addedDate() {
        return this.addedDateField.value();
    }

    get removedDate() {
        return this.removedDateField.value();
    }

    populateOptions() {
        let current = this._activeLayerId;
        this.selectEl.innerHTML = '';
        let none = document.createElement('option');
        none.value = '';
        none.textContent = 'No layer';
        this.selectEl.appendChild(none);

        Object.values(this.layers.collection).forEach(layer => {
            let option = document.createElement('option');
            option.value = layer.id;
            option.textContent = layer.name;
            this.selectEl.appendChild(option);
        });

        if (current && this.layers.get(current)) {
            this.selectEl.value = current;
        } else {
            this._activeLayerId = null;
            this.selectEl.value = '';
        }
    }

    get activeLayer() {
        return this._activeLayerId ? this.layers.get(this._activeLayerId) : null;
    }

    get activeLayerId() {
        return this._activeLayerId;
    }

    setActiveLayer(layerId) {
        this._activeLayerId = layerId;
        this.populateOptions();
        if (layerId) {
            this.selectEl.value = layerId;
        }
    }

    show(beside = false) {
        this.populateOptions();
        this.container.show();
        if (beside) {
            this.container.class('planner-active-layer planner-ui-overlay beside-menu');
        } else {
            this.container.class('planner-active-layer planner-ui-overlay');
        }
    }

    hide() {
        this.container.hide();
    }
}
